/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetBillingStripeCreditBalance200ResponseBalance } from './GetBillingStripeCreditBalance200ResponseBalance';
import {
    GetBillingStripeCreditBalance200ResponseBalanceFromJSON,
    GetBillingStripeCreditBalance200ResponseBalanceFromJSONTyped,
    GetBillingStripeCreditBalance200ResponseBalanceToJSON,
    GetBillingStripeCreditBalance200ResponseBalanceToJSONTyped,
} from './GetBillingStripeCreditBalance200ResponseBalance';

/**
 * 
 * @export
 * @interface GetBillingStripeCreditBalance200Response
 */
export interface GetBillingStripeCreditBalance200Response {
    /**
     * 
     * @type {GetBillingStripeCreditBalance200ResponseBalance}
     * @memberof GetBillingStripeCreditBalance200Response
     */
    balance?: GetBillingStripeCreditBalance200ResponseBalance | null;
}

/**
 * Check if a given object implements the GetBillingStripeCreditBalance200Response interface.
 */
export function instanceOfGetBillingStripeCreditBalance200Response(value: object): value is GetBillingStripeCreditBalance200Response {
    return true;
}

export function GetBillingStripeCreditBalance200ResponseFromJSON(json: any): GetBillingStripeCreditBalance200Response {
    return GetBillingStripeCreditBalance200ResponseFromJSONTyped(json, false);
}

export function GetBillingStripeCreditBalance200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBillingStripeCreditBalance200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'balance': json['balance'] == null ? undefined : GetBillingStripeCreditBalance200ResponseBalanceFromJSON(json['balance']),
    };
}

export function GetBillingStripeCreditBalance200ResponseToJSON(json: any): GetBillingStripeCreditBalance200Response {
    return GetBillingStripeCreditBalance200ResponseToJSONTyped(json, false);
}

export function GetBillingStripeCreditBalance200ResponseToJSONTyped(value?: GetBillingStripeCreditBalance200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'balance': GetBillingStripeCreditBalance200ResponseBalanceToJSON(value['balance']),
    };
}

